<template>
  <div>
    <v-container>
      <template v-if="currentPromotion">
        <div class="row">
          <h3 class="headline col s9 mt-0 ml-0">{{ $t('Popup and Banner') }}</h3>
          <div class="col s3 text-xs-right">
            <div
              class="btn-floating btn-outline-red text-xs-center"
              style="margin-left: 5px; margin-bottom: 5px"
              v-if="!isEdit"
              @click="onClickEdit"
            >
              <em class="fa fa-pencil-alt middle" />
            </div>
          </div>
        </div>
        <div class="caption">Popup Image</div>
        <div class="mb-3">
          <div v-if="isEdit">
            <uploadfile
              v-model="currentPromotion.popup_image"
              :height="250"
              @onUploaded="onUploaded"
            ></uploadfile>
          </div>
          <template v-else>
            <img
              :src="currentPromotion.popup_image"
              @error="imgError"
              style="width: 100%; border: 1px solid #eee; border-radius: 10px; max-width: 300px"
            />
          </template>
        </div>
        <div class="caption">Banner text</div>
        <div class="primary--text mb-3" v-if="!isEdit">
          {{ currentPromotion.banner_text ? currentPromotion.banner_text : '-' }}
        </div>
        <div class="form-control mb-3" v-else>
          <input type="text" v-model="currentPromotion.banner_text" />
        </div>
        <div class="caption">Popup text</div>
        <div class="primary--text mb-3" v-if="!isEdit">
          {{ currentPromotion.popup_text ? currentPromotion.popup_text : '-' }}
        </div>
        <div class="form-control mb-3" v-else>
          <input type="text" v-model="currentPromotion.popup_text" />
        </div>

        <div class="caption">Product id</div>
        <div class="primary--text mb-3" v-if="!isEdit">
          {{ currentPromotion.popup_addproductid ? currentPromotion.popup_addproductid : '-' }}
        </div>
        <div class="form-control mb-3" v-else>
          <input type="text" v-model="currentPromotion.popup_addproductid" />
        </div>

        <div class="caption">Product price</div>
        <div class="primary--text mb-3" v-if="!isEdit">
          {{
            currentPromotion.popup_addproductprice ? currentPromotion.popup_addproductprice : '-'
          }}
        </div>
        <div class="form-control mb-3" v-else>
          <input type="text" v-model="currentPromotion.popup_addproductprice" />
        </div>

        <div class="caption">Product sku</div>
        <div class="primary--text mb-3" v-if="!isEdit">
          {{ currentPromotion.popup_addproductsku ? currentPromotion.popup_addproductsku : '-' }}
        </div>
        <div class="form-control mb-3" v-else>
          <input type="text" v-model="currentPromotion.popup_addproductsku" />
        </div>

        <div class="text-xs-center" v-if="isEdit">
          <v-btn color="grey" outline @click="onCancelEdit">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" depressed @click="onSaveEdit">{{ $t('Save') }}</v-btn>
        </div>
      </template>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import uploadfile from '@/components/elements/uploadfile'
export default {
  data() {
    return {
      currentPromotion: null,
      isEdit: false
    }
  },
  components: {
    uploadfile
  },
  async mounted() {
    this.currentPromotion = await this.getDplusPromotion()
  },
  methods: {
    onCancelEdit() {
      this.currentPromotion = JSON.parse(this.cached_currentPromotion)
      this.isEdit = false
    },
    async onSaveEdit() {
      try {
        this.$store.dispatch('loading')
        var result = this.$validator.validateAll()
        if (!result) {
          this.goToErrorInput()
          this.$store.dispatch('loading')
          return false
        }
        await this.saveDplusPromotion()
        this.$store.dispatch('loading')
        this.cached_currentPromotion = JSON.stringify(this.currentPromotion)
        this.isEdit = false
      } catch (error) {
        this.$store.dispatch('loading')
      }
    },
    saveDplusPromotion() {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = vm.currentPromotion
        api.updateDplusPromotion(data, function (error, response) {
          if (error) {
            reject(error)
          }
          if (response.responsecode == 200) {
            resolve()
          } else {
            reject()
          }
        })
      })
    },
    onUploaded: function (image) {
      this.currentPromotion.popup_image = image
    },
    onClickEdit() {
      this.cached_currentPromotion = JSON.stringify(this.currentPromotion)
      this.isEdit = true
    },
    getDplusPromotion() {
      return new Promise((resolve, reject) => {
        var data = null
        api.getDplusPromotion(data, function (error, response) {
          if (error) {
            reject(error)
          }
          if (response.responsecode == 200 && response.data) {
            resolve(response.data)
          } else {
            resolve({
              banner_text: '',
              id: '',
              popup_addproductid: '',
              popup_addproductprice: '',
              popup_addproductsku: '',
              popup_image: '',
              popup_text: ''
            })
          }
        })
      })
    },
    imgError: function (event) {
      $(event.target).attr('src', '/static/img/assets/generic/generic_default_thumbnail.png')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/dplus/main.vue